/**
 * 闪现特殊上报
 * @param {string} reportPv 活动配置
 * @param {*} sxEventtype 
 * @param {*} sxExtendid 
 * @returns 
 */
function sparkReport(reportPv = '', sxEventtype, sxExtendid) { // 闪现活动上报
  if (reportPv === '') {
    console.warn('missing reportPv param');
    return false;
  }
  const [sxContentid, sxContentname] = reportPv.split('|');
  window?.gameCommunityJsSdk?.report({
    pageid: '2501',
    moduleid: '00001',
    eventtype: sxEventtype,
    extendid: sxExtendid,
    contentid: sxContentid,
    contentname: sxContentname,
  });
}

export default {
  install(Vue) {
    Vue.prototype.$reportTgclubPlugin = {
      async init() {
        // 插入上报库的js文件
      },
      async click(params) {
        console.log('tgclub report.click, params=', params);
      },
      async expose(params) {
        console.log('tgclub report.expose, params=', params);
      },
      async trackClick(trackClickOption) {
        const astConfig = Vue.prototype.$ast.currentAstConfig();
        switch (astConfig.NAME) {
          case 'SPARK': {
            const actInfo = Vue.prototype.$actInfo;
            const pageId = actInfo.page_id;
            const { reportPv = '' } = actInfo.config.configs[pageId].canvasConfig;
            if (reportPv === '') {
              console.warn('missing reportPv param');
              return false;
            }
            // component_config: { report_pv, report_click }
            const { reportClick = '', reportExpose = '' } = trackClickOption?.component_config?.styles?.base;
            console.log({ reportClick, reportExpose });
            const { event_id: eventId, ext } = trackClickOption;
            // 点击事件
            if (reportClick && reportClick !== '') {
              if (eventId === '1045' && ext?.status === undefined) {
                console.log('上报点击事件', reportClick.split(','));
                const [type, id] = reportClick.split(',');
                sparkReport(reportPv, type, id);
              }
            }
            // 成功事件
            if (reportExpose && reportExpose !== '') {
              if (ext?.status === '1') {
                console.log('上报抽奖、领取成功', reportExpose.split(','));
                const [type1, id1] = reportExpose.split(',');
                sparkReport(reportPv, type1, id1);
              }
            }
            break;
          }
          default:
            break;
        }
      },
    };
  },
};
